import React, { useEffect, useState } from 'react';
import {
	getUnitSoldForCurrentAgent,
	getAllUnitSold,
} from '../../../api/Dashboard/getUnitSold.api';
import styles from './UnitSoldTable.module.scss';
import {
	Card,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TableSortLabel,
	TablePagination,
} from '@material-ui/core';
import { numberWithCommas } from '../../../utils/numberWithCommas';

const UnitSoldTable = ({ salesAgentId, filterByDate }) => {
	const [lotArr, setLotArr] = useState([]);
	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('lotId');
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);

	useEffect(() => {
		if (salesAgentId && salesAgentId !== 'allSalesAgents') {
			getUnitSoldForCurrentAgent(
				salesAgentId,
				filterByDate,
				(returned) => {
					setLotArr(returned);
				}
			);
		} else if (salesAgentId === 'allSalesAgents') {
			getAllUnitSold(filterByDate, (returned) => {
				setLotArr(returned);
			});
		}
	}, [salesAgentId, filterByDate]);

	useEffect(() => {
		console.log('lotArr', lotArr);
	}, [lotArr]);

	const headCells = [
		{ id: 'lotName', label: 'Model' },
		{ id: 'lotId', label: '# of Units' },
		{ id: 'totalCost', label: 'Revenue' },
	];

	const handleRequestSort = (property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const descendingComparator = (a, b, orderBy) => {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	};

	const getComparator = (order, orderBy) => {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	};

	const stableSort = (array, comparator) => {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map((el) => el[0]);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	return (
		<Card className={styles.lot_sold_card_group} variant='outlined'>
			<TableContainer
				component={Paper}
				className={styles.tableContainer}
				style={{ height: '100%' }}
			>
				<div className={styles.wrapper}>
					<div className={styles.card_title}>
						Units Sold (
						{lotArr.reduce((prev, cur) => prev + cur.number, 0)})
					</div>
					<Table>
						<TableHead>
							<TableRow>
								{headCells.map((headCell) => (
									<TableCell key={headCell.id}>
										<TableSortLabel
											active={orderBy === headCell.id}
											direction={
												orderBy === headCell.id
													? order
													: 'asc'
											}
											onClick={() => {
												handleRequestSort(headCell.id);
											}}
										>
											{headCell.label}
										</TableSortLabel>
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						{lotArr.length > 0 ? (
							<TableBody>
								{stableSort(
									lotArr,
									getComparator(order, orderBy)
								)
									.slice(
										page * rowsPerPage,
										page * rowsPerPage + rowsPerPage
									)
									.map((lot, index) => {
										return (
											<TableRow key={lot.name}>
												<TableCell>
													{lot.name}
												</TableCell>
												<TableCell>
													{lot.number}
												</TableCell>
												<TableCell>
													${' '}
													{numberWithCommas(
														lot.totalCost
													)}
												</TableCell>
											</TableRow>
										);
									})}
							</TableBody>
						) : (
							<div className={styles.noSales}>
								No results found.
							</div>
						)}
					</Table>
				</div>
				<TablePagination
					rowsPerPageOptions={[5, 10]}
					component='div'
					count={lotArr.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
					className={styles.tablePagination}
					labelRowsPerPage={
						<div style={{ color: 'var(--text-high-emphasis)' }}>
							Rows per page
						</div>
					}
					nextIconButtonProps={{
						style: {
							padding: '0px',
						},
					}}
					backIconButtonProps={{
						style: {
							padding: '0px',
							marginLeft: '-10px',
						},
					}}
					SelectProps={{
						style: {
							border: '1px solid var(--text-mid-emphasis)',
							borderRadius: '4px',
							padding: '4px',
							marginRight: '10px',
						},
					}}
				/>
			</TableContainer>
		</Card>
	);
};

export default UnitSoldTable;
